import {Component} from '@angular/core';
@Component({
  selector: 'ithera-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent {

}



// WEBPACK FOOTER //
// ./src/app/shared/header/header.component.ts